import * as React from "react";
import {
    List,
    Datagrid,
    TextField,
    EditButton,
    Edit,
    Create,
    SimpleForm,
    TextInput,
    SelectInput,
    DateField,
    DateInput,
    ReferenceField,
    ShowButton,
    SelectField
} from 'react-admin';

export const AppraisalTaskList = props => (
    <List {...props}>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="Title" label="标题" />
            <DateField source="StartTime" label="开始时间" />
            <DateField source="EndTime" label="结束时间" />
            <SelectField source="Status" label="状态" choices={[
                { id: 0, name: '未开始' },
                { id: 1, name: '进行中' },
                { id: 2, name: '已结束' },
            ]} />
            <EditButton />
            <ShowButton />
        </Datagrid>
    </List>
);

export const AppraisalTaskEdit = props => (
    <Edit {...props}>
        <SimpleForm>
            <TextInput disabled source="id" />
            <TextInput source="Title" label="标题" />
            <TextInput multiline source="Content" label="内容" />
            <DateInput source="StartTime" label="开始时间" />
            <DateInput source="EndTime" label="结束时间" />
            <SelectInput source="Status" label="状态" choices={[
                { id: 0, name: '未开始' },
                { id: 1, name: '进行中' },
                { id: 2, name: '已结束' },
            ]} />
        </SimpleForm>
    </Edit>
);

export const AppraisalTaskCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="Title" label="标题" />
            <TextInput multiline source="Content" label="内容" />
            <DateInput source="StartTime" label="开始时间" />
            <DateInput source="EndTime" label="结束时间" />
            <SelectInput source="Status" label="状态" choices={[
                { id: 0, name: '未开始' },
                { id: 1, name: '进行中' },
                { id: 2, name: '已结束' },
            ]} />
        </SimpleForm>
    </Create>
);
